import { createApiRequest } from "../common";

/**
 * Tier C — reprocess an orphaned (or analysis-failed) thread into a FRESH deal.
 *
 * Server-only route (`POST /inbox/thread/reprocess`) — there is no Smithy
 * *RequestContent type for it (it's an inbox-recovery flag, not part of the
 * typed deal CRUD surface), so the request/response shapes are declared locally
 * to mirror the api-server handler (handlers/inbox-thread.ts). The handler
 * clears the stale ingest-idempotency binding via a Deal Manager op, then
 * re-runs ingest → a brand-new deal (no resurrection of the deleted one).
 */
export interface ReprocessThreadRequest {
  externalThreadId: string;
  /** 'email' | 'imessage'. Defaults to 'email' server-side. */
  channel?: string;
}

export interface ReprocessThreadResponse {
  externalThreadId: string;
  channel: string;
  /** True when a stale ingest binding existed and was cleared. */
  idempotencyCleared: boolean;
  /** The ingest workflow id fired to mint the fresh deal. */
  workflowId: string;
}

export const reprocessThreadApi = async (
  request: ReprocessThreadRequest,
): Promise<ReprocessThreadResponse> => {
  const apiRequest = createApiRequest<ReprocessThreadResponse>(
    "post",
    "/inbox/thread/reprocess",
  );
  return apiRequest(request);
};
